let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1yDVc")).then(() => parcelRequire('7JbDo'));